export const LIST_PROCESS_RESEND_ORDER_LIS_REQUEST =
  'LIST_PROCESS_RESEND_ORDER_LIS_REQUEST'
export const LIST_PROCESS_RESEND_ORDER_LIS_SUCCESS =
  'LIST_PROCESS_RESEND_ORDER_LIS_SUCCESS'
export const LIST_PROCESS_RESEND_ORDER_LIS_FAILURE =
  'LIST_PROCESS_RESEND_ORDER_LIS_FAILURE'

export const CREATE_NEW_ORDER_LIS_REQUEST = 'CREATE_NEW_ORDER_LIS_REQUEST'
export const CREATE_NEW_ORDER_LIS_SUCCESS = 'CREATE_NEW_ORDER_LIS_SUCCESS'
export const CREATE_NEW_ORDER_LIS_FAILURE = 'CREATE_NEW_ORDER_LIS_FAILURE'

export const UPDATE_ORDER_LIS_REQUEST = 'UPDATE_ORDER_LIS_REQUEST'
export const UPDATE_ORDER_LIS_SUCCESS = 'UPDATE_ORDER_LIS_SUCCESS'
export const UPDATE_ORDER_LIS_FAILURE = 'UPDATE_ORDER_LIS_FAILURE'

export const LIST_RESEND_ORDER_LIS_REQUEST = 'LIST_RESEND_ORDER_LIS_REQUEST'
export const LIST_RESEND_ORDER_LIS_SUCCESS = 'LIST_RESEND_ORDER_LIS_SUCCESS'
export const LIST_RESEND_ORDER_LIS_FAILURE = 'LIST_RESEND_ORDER_LIS_FAILURE'

export const DETAIL_LIST_PROCESS_RESEND_ORDER_LIS_REQUEST =
  'DETAIL_LIST_PROCESS_RESEND_ORDER_LIS_REQUEST'
export const DETAIL_LIST_PROCESS_RESEND_ORDER_LIS_SUCCESS =
  'DETAIL_LIST_PROCESS_RESEND_ORDER_LIS_SUCCESS'
export const DETAIL_LIST_PROCESS_RESEND_ORDER_LIS_FAILURE =
  'DETAIL_LIST_PROCESS_RESEND_ORDER_LIS_FAILURE'

export const DETAIL_PROCESS_RESEND_ORDER_LIS_REQUEST =
  'DETAIL_PROCESS_RESEND_ORDER_LIS_REQUEST'
export const DETAIL_PROCESS_RESEND_ORDER_LIS_SUCCESS =
  'DETAIL_PROCESS_RESEND_ORDER_LIS_SUCCESS'
export const DETAIL_PROCESS_RESEND_ORDER_LIS_FAILURE =
  'DETAIL_PROCESS_RESEND_ORDER_LIS_FAILURE'

export const EXPORT_PROCESS_RESEND_ORDER_LIS_REQUEST =
  'EXPORT_PROCESS_RESEND_ORDER_LIS_REQUEST'
export const EXPORT_PROCESS_RESEND_ORDER_LIS_SUCCESS =
  'EXPORT_PROCESS_RESEND_ORDER_LIS_SUCCESS'
export const EXPORT_PROCESS_RESEND_ORDER_LIS_FAILURE =
  'EXPORT_PROCESS_RESEND_ORDER_LIS_FAILURE'
